import React, { useState } from "react";
import {
  FaTachometerAlt,
  FaUsers,
  FaChalkboardTeacher,
  FaUserFriends,
  FaBook,
  FaRegMoneyBillAlt,
  FaClipboardList,
  FaSchool,
  FaBus,
  FaNewspaper,
  FaBookOpen,
  FaBars,
  FaTimes,
  FaSearch,
  FaBell,
  FaEnvelope,
  FaUser,
} from "react-icons/fa";
import { RiMenu3Line } from "react-icons/ri";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { FaRegCircleUser } from "react-icons/fa6";
import { Button, Layout, Menu, theme } from "antd";
import { useSelector } from "react-redux";
import { Link, useNavigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import { MdOutlineSubject } from "react-icons/md";
import { MdOutlineEmojiTransportation } from "react-icons/md";
import { MdOutlineNotificationsActive } from "react-icons/md";
import { TbNewSection } from "react-icons/tb";
import { RxDashboard } from "react-icons/rx";
import { PiStudent } from "react-icons/pi";
import { IoSchoolOutline } from "react-icons/io5";
import { LuMapPin } from "react-icons/lu";
import { MdOutlineLocalFireDepartment } from "react-icons/md";
import { SiGoogleclassroom } from "react-icons/si";
import { MdOutlineManageAccounts } from "react-icons/md";
import { LiaChalkboardTeacherSolid } from "react-icons/lia";
import { RiParentLine } from "react-icons/ri";
import { FcDepartment } from "react-icons/fc";
import { SiCoursera } from "react-icons/si";
import { PiExamThin } from "react-icons/pi";
import { IoLibraryOutline } from "react-icons/io5";
import logo from "../Assets/oakyalogoIMG1.png";
const { Header, Content, Sider } = Layout;

const AdminPanel = () => {
  const user = useSelector((state) => state?.user?.user);
  const navigate = useNavigate();
  const { token } = theme.useToken();
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [isMenuItemsVisible, setIsMenuItemsVisible] = useState(true);
  const [openMenuItem, setOpenMenuItem] = useState(null);
  const [subItemOpen, setSubItemOpen] = useState({});

  const handleLogout = () => {
    Cookies.remove("admin_id");
    navigate("/admin-login");
  };

  // This function now only toggles menu visibility, not sidebar
  const toggleMenuItems = () => {
    setIsMenuItemsVisible(!isMenuItemsVisible);
  };

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const menuItems = [
    {
      label: "Dashboard",
      icon: <RxDashboard className="text-[#ffa404]" />,
      subItems: [
        {key:"dashboard", label: "Admin" },
        // { key: "studentdashboard", label: "Students" },
        // { label: "Parents" },
      ],
    },
    {
      label: "Students",
      icon: <PiStudent className="text-[#ffa404]" />,
      subItems: [
        { key: "allStudents", label: "All Students" },
        // { key: "studentDetails", label: 'Student Details' },
        { key: "stuadmissionForm", label: "Admission Form" },
      ],
    },
    {
      label: "Teachers",
      icon: <LiaChalkboardTeacherSolid className="text-[#ffa404]" />,
      subItems: [
        { key: "allProfessor", label: "All Professor" },
        // { key: "studentDetails", label: "Parents Details" },
        { key: "addProfessor", label: "Add Professor" },
      ],
    },
    // {
    //   label: "Parents",
    //   icon: <RiParentLine className="text-[#ffa404]" />,
    //   subItems: [
    //     { key: "allStudents", label: "All Parents" },
    //     { key: "studentDetails", label: "Parents Details" },
    //     { key: "addProfessor", label: "Add Parent" },
    //   ],
    // },
    // { label: "Library", icon: <IoLibraryOutline className="text-[#ffa404]" /> },
    // {
    //   label: "Accounts",
    //   icon: <MdOutlineManageAccounts className="text-[#ffa404]" />,
    // },
    // {
    //   label: "Class",
    //   icon: <SiGoogleclassroom className="text-[#ffa404]" />,
    //   subItems: [
    //     { key: "allclass", label: "All Classes" },
    //     { key: "addclass", label: "Add New Class" },
    //   ],
    // },
    {
      label: "Section",
      icon: <TbNewSection className="text-[#ffa404]" />,
      subItems: [
        { key: "allsection", label: "All Section" },
        { key: "addsection", label: "Add New Section" },
      ],
    },
    // {
    //   key: "subjects",
    //   label: "Subject",
    //   icon: <MdOutlineSubject className="text-[#ffa404]" />,
    // },
    {
      key: "department",           
      label: "Department",
      icon: <MdOutlineLocalFireDepartment className="text-[#ffa404]" />,
      subItems: [
        { key: "alldepartments", label: "All Departments" },
        { key: "adddepartment", label: "Add New Department" },
      ],
    },
    {
      key: "course",      
      label: "Courses",
      icon: <SiCoursera className="text-[#ffa404]" />,
      subItems: [                                   
        { key: "allcourses", label: "All Courses" },
        { key: "addcourses", label: "Add New Course" },
      ],
    },
    // {
    //   label: "Attendance",
    //   icon: <IoSchoolOutline className="text-[#ffa404]" />,
    // },
    // { label: "Exam", icon: <PiExamThin className="text-[#ffa404]" /> },
    // {
    //   label: "Transport",
    //   icon: <MdOutlineEmojiTransportation className="text-[#ffa404]" />,
    // },
    {
      key: "notifications",
      label: "Notification",
      icon: <MdOutlineNotificationsActive className="text-[#ffa404]" />,
      subItems: [
        { key: "allNotifications", label: "All Notifications" },
        // { key: "addNotifications", label: "Create Notifications" },
      ],
    },
    // { label: "Map", icon: <LuMapPin className="text-[#ffa404]" /> },
  ];

  const handleMenuClick = (label) => {
    if (openMenuItem === label) {
      setOpenMenuItem(null); // If clicked again, close it
    } else {
      setOpenMenuItem(label); // Otherwise, open it
    }
  };

  const toggleSubItem = (label) => {
    setSubItemOpen((prevState) => ({
      ...prevState,
      [label]: !prevState[label],
    }));
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
      <Sider
        width={250}
        style={{
          // background: "#ffa404",
          position: "fixed",
          height: "100vh",
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 1000,
          transition: "transform 0.3s ease",
          transform: isSidebarVisible ? "translateX(0)" : "translateX(-100%)",
        }}
      >
        {/* Close Button */}
        <Button
          type="text"
          onClick={toggleMenuItems} // This button now only toggles the visibility of menu items
          style={{
            fontSize: "20px",
            color: "white",
            background: "transparent",
            border: "none",
            position: "absolute",
            top: "27px",
            right: "10px",
          }}
        >
          <RiMenu3Line size={35} />
        </Button>

        {/* Admin Profile */}
        {/* <a href="/dashboard">
          <div className="flex flex-col items-center p-1 mt-[4%]">
            <div className="text-3xl cursor-pointer">
              {user?.profilePic ? (
                <img
                  src={user?.profilePic}
                  className="w-12 h-12 rounded-full"
                  alt={user?.name}
                />
              ) : (
                <FaRegCircleUser className="text-white text-2xl" />
              )}
            </div>
            <p className="capitalize text-sm font-semibold text-white mt-2">ADMIN</p>
          </div>
        </a> */}
        <a className="/">
          <div className="flex flex-col pl-3 bg-[#ffa404] mt-[-4%] cursor-pointer">
            <img src={logo} className="w-[50%] rounded-full" alt={logo} />
          </div>
        </a>

        {/* Menu Items */}
        {isMenuItemsVisible && (
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={[]}
            onClick={({ key }) => handleMenuClick(key)}
          >
            <div className="overflow-y-auto max-h-[calc(94vh-50px)]">
              {" "}
              {/* Add vertical scrolling */}
              {menuItems.map((item, index) => (
                <div key={index}>
                  <div
                    className={`bg-[#042954] p-2 rounded-md hover:bg-gray-400 cursor-pointer flex items-center justify-between  ${
                      openMenuItem === item.label ? "text-[#ffa404]" : ""
                    }`}
                    onClick={() => handleMenuClick(item.label)}
                  >
                    <div className="flex items-center space-x-3 p-2">
                      <div className="text-xl">{item.icon}</div>
                      <span className="text-[14.5px] ">{item.label}</span>
                    </div>

                    {item.subItems && (
                      <div>
                        {openMenuItem === item.label ? (
                          <MdKeyboardArrowDown
                            className="text-[#ffa404]"
                            size={20}
                          />
                        ) : (
                          <MdKeyboardArrowRight size={20} />
                        )}
                      </div>
                    )}
                  </div>

                  <div className="border-b-2 border-[#000]"></div>

                  {item.subItems && openMenuItem === item.label && (
                    <div className="pl-8">
                      {item.subItems.map((subItem, subIndex) => (
                        <Link to={`/${subItem.key}`} key={subIndex}>
                          <div
                            className="flex items-center cursor-pointer p-2 hover:bg-gray-500 text-white"
                            onClick={() => toggleSubItem(subItem.label)}
                          >
                            <div className="mr-2">
                              {subItemOpen[subItem.label] ? (
                                <MdKeyboardArrowDown size={20} />
                              ) : (
                                <MdKeyboardArrowRight size={20} />
                              )}
                            </div>
                            <span>{subItem.label}</span>
                          </div>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </Menu>
        )}
      </Sider>

      <Layout
        style={{
          marginLeft: isSidebarVisible ? 250 : 0,
          transition: "margin-left 0.3s ease",
        }}
      >
        <Header
          className="site-layout-background"
          style={{
            padding: "0 16px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#fff",
            position: "sticky",
            top: 0,
            zIndex: 999,
            height: "64px",
          }}
        >
          {/* Menu Icon when Sidebar is Closed */}
          {!isSidebarVisible && (
            <Button
              type="text"
              onClick={() => setIsSidebarVisible(!isSidebarVisible)}
              style={{
                fontSize: "24px",
                color: "white",
                background: "transparent",
                border: "none",
                position: "absolute",
                left: "16px",
                top: "16px",
              }}
            >
              <AiOutlineClose />
            </Button>
          )}
          <div className="w-full flex justify-between items-center">
            {/* Left: Search Bar */}
            <div className="flex items-center  p-2 rounded-md">
              <FaSearch className="text-gray-400 mr-2" />
              <input
                type="text"
                className="border-none outline-none text-gray-700 text-sm"
                placeholder="Find Something ..."
              />
            </div>

            {/* Right: Icons */}
            <div className="flex gap-6">
              <FaBell className="text-gray-700 text-xl cursor-pointer hover:text-blue-500" />
              <FaEnvelope className="text-gray-700 text-xl cursor-pointer hover:text-blue-500" />
              <FaUser className="text-gray-700 text-xl cursor-pointer hover:text-blue-500" />
            </div>
          </div>
        </Header>

        {/* Logout Button */}
        <div style={{ position: "absolute", top: "16px", right: "20px" }}>
          <Button
            type="text"
            onClick={handleLogout}
            style={{
              backgroundColor: "#DC2626",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              transition: "background-color 0.3s",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#B91C1C")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#DC2626")
            }
          >
            Logout
          </Button>
        </div>

        {/* Content */}
        <Content
          style={{
            margin: "20px 16px",
            padding: 24,
            minHeight: 280,
            background: "#f0f1f3",
            borderRadius: token.borderRadiusLG,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminPanel;
